module.exports = __webpack_public_path__ + "static/media/purple_jeff.452b661e.jpg";